// День в миллисекундах
export const DAY = 1000 * 60 * 60 * 24;

/*
Получить 00:00 текущего дня по UTC (timestamp)
 */
export function getUtcToday(): number {
	const date = new Date();
	date.setUTCHours(0, 0, 0, 0);

	return date.getTime();
}

/**
 * Проверить, что переданная дата старше, чем сегодня,
 * на заданное количество дней (включительно)
 * @param date
 * @param days
 */
export function isDateOlderThan(date: number, days: number) {
	return getUtcToday() - days * DAY >= date;
}
